import { createElement, hydrate } from 'preact/compat';
import Page from 'virtual:page:entry-page:index';

hydrate(createElement(Page, null), document.getElementById('app'));
